{
  "connect": "Подключиться",
  "mode": "Режим",
  "viewOnly": "Только просмотр",
  "loadingSettings": "Загружаем параметры…",
  "probeServer": "Проверить сервер",
  "notProbedYet": "Сервер ещё не проверяли — платформа сделает это при первом подключении.",
  "serverNotIdentified": "сервер не опознан",
  "hasFileTransfer": ", есть передача файлов",
  "probedAt": "проверено {{at}}",
  "serverInfo": "Сведения о сервере",
  "noOpenSessions": "Открытых сессий нет",
  "noOpenSessionsHint": "Подключение к машине начинается с карты сети или экрана узлов: выберите узел и нажмите «Подключиться». К одной машине открывается одна вкладка.",
  "closeTab": "Закрыть вкладку {{name}}",
  "serverKind": {
    "auto": "Определять автоматически",
    "tightvnc": "TightVNC",
    "ultravnc": "UltraVNC",
    "tigervnc": "TigerVNC",
    "realvnc": "RealVNC",
    "x11vnc": "x11vnc",
    "other": "Другой"
  },
  "encoding": "Кодировка",
  "securityType": {
    "none": "без аутентификации",
    "vncAuth": "VNC Authentication",
    "ra2": "RSA-AES (RA2)",
    "ra2ne": "RSA-AES без шифрования (RA2ne)",
    "tight": "Tight",
    "ultra": "UltraVNC",
    "realvnc": "проприетарная аутентификация RealVNC",
    "vencrypt": "VeNCrypt",
    "appleArd": "Apple Screen Sharing",
    "numbered": "тип {{type}}"
  },
  "serverKindUnknown": "определить не удалось",
  "info": {
    "server": "Сервер",
    "unknownKind": "определить не удалось",
    "rfbVersion": "Версия RFB",
    "desktop": "Рабочий стол",
    "desktopHint": "Единственное, что сервер сообщает о себе строкой: своего поля версии в RFB нет",
    "route": "Маршрут",
    "viaAgent": "через агента площадки",
    "direct": "напрямую",
    "encoding": "Кодировка",
    "encodingHint": "Первая в списке, предложенном серверу. Какую он выбрал, RFB не сообщает",
    "securityTypes": "Типы входа",
    "capabilities": "Возможности",
    "clipboard": "буфер обмена",
    "fileTransfer": "передача файлов",
    "viewOnly": "только просмотр",
    "screenAndInputOnly": "только экран и управление"
  },
  "scaling": {
    "fit": "Вписать",
    "native": "1:1",
    "remote": "По размеру окна",
    "remoteUnavailable": "Этот сервер не умеет менять разрешение рабочего стола по просьбе клиента"
  },
  "combo": {
    "altTab": "Переключение окон на удалённой машине",
    "altF4": "Закрыть окно на удалённой машине",
    "taskManager": "Диспетчер задач Windows",
    "explorer": "Проводник",
    "run": "Окно «Выполнить»",
    "lock": "Заблокировать удалённую машину"
  },
  "toolbar": {
    "viewOnlyLocked": "Задано в свойствах узла: ввод не доходит до машины и кнопкой не включается",
    "takeControl": "Взять управление",
    "viewOnlyHint": "Смотреть, не трогая: браузер перестанет отправлять клавиши и мышь",
    "viewOnlyOn": "Включён режим просмотра",
    "sendCad": "Отправить Ctrl+Alt+Del",
    "combos": "Комбинации",
    "clipboard": "Буфер обмена",
    "pasteDisabled": "В режиме просмотра вставка на машину недоступна",
    "fromMachine": "С машины",
    "toMachine": "На машину",
    "nothingCopied": "Машина ничего не копировала за эту сессию",
    "pastePlaceholder": "Текст, который нужно вставить на удалённой машине",
    "send": "Отправить",
    "files": "Файлы",
    "filesHint": "Файлы удалённой машины поверх экрана",
    "quality": "Качество",
    "qualityAria": "Качество изображения",
    "compression": "Сжатие",
    "compressionAria": "Уровень сжатия",
    "latencyHint": "Задержка до машины",
    "noLatency": "— мс",
    "bytesHint": "Принято за сессию",
    "fullscreen": "Во весь экран",
    "disconnect": "Отключиться"
  },
  "screen": {
    "connecting": "Подключаемся к машине…",
    "requestingTicket": "Запрашиваем разрешение на подключение",
    "closed": "Сессия закрыта",
    "failed": "Подключиться не удалось",
    "finished": "Соединение с машиной завершено",
    "closedByPeer": "Соединение закрыто",
    "lost": "Соединение с машиной потеряно",
    "openFailed": "Не удалось открыть сессию",
    "viewOnlyByNode": "Только просмотр — так настроен узел, ввод до машины не доходит",
    "viewOnlyOnPhone": "Только просмотр — рабочим столом с телефона не управляют",
    "viewOnlyByToolbar": "Только просмотр — так открывается сессия; управление берут кнопкой на панели",
    "hideInfo": "Скрыть сведения",
    "info": "Сведения",
    "reconnect": "Подключиться заново"
  },
  "hint": {
    "ticketInvalid": "Тикет одноразовый и живёт тридцать секунд. Нажмите «Подключиться заново».",
    "noCredential": "Привяжите к узлу учётные данные VNC в его свойствах.",
    "authFailed": "Проверьте пароль в учётных данных. Пароль VNC длиннее восьми символов сервер обрезает.",
    "portClosed": "Проверьте, запущен ли VNC-сервер на машине и тот ли порт указан в свойствах узла.",
    "securityUnsupported": "Такой способ входа платформа не поддерживает. Настройте на сервере VNC Authentication.",
    "sessionLimit": "Закройте одну из открытых вкладок и попробуйте снова.",
    "permissionDenied": "Право `vnc:connect` выдаётся ролью или точечно на узел. Обратитесь к администратору организации.",
    "agentOffline": "Агент площадки не на связи. Проверьте службу netdeck-agent."
  },
  "server": "Сервер",
  "tabsCount": "{{open}} из {{max}}"
}
